import CityLandingPage from './page';

const recifeData = {
  cityName: 'Recife',
  state: 'PE',
  slug: 'palestra-silenciosa-recife',
  coordinates: {
    lat: -8.0476,
    lng: -34.877,
  },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa recife',
    'silent conference recife',
    'aluguel fones sem fio recife',
    'eventos corporativos recife',
    'tradução simultânea recife',
    'silent disco recife',
    'locação fones sem fio recife',
    'equipamentos e profissionais em recife',
  ],
  heroTitle: 'palestra silenciosa recife',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos, conferências multilíngues e workshops em Recife e Pernambuco, com equipamentos e profissionais presentes na cidade. Transforme seu evento com palestra silenciosa.',
  localPresence: 'A STIB atua em Recife com equipamentos e profissionais presentes na cidade: fones, transmissores e equipe técnica em campo para montagem, operação e suporte presencial. Atendemos Recife e a Região Metropolitana; para o interior de Pernambuco, consulte a disponibilidade. Não há escritório físico na cidade, e o orçamento é centralizado pelo WhatsApp (11) 91777-6227.',
  localTestimonials: [],
  localFAQs: [
    {
      question: 'A STIB tem equipamentos e equipe técnica em Recife?',
      answer: 'Sim. A STIB conta com equipamentos e profissionais presentes em Recife, o que facilita a montagem, o suporte técnico presencial e a resposta rápida para eventos na cidade e na Região Metropolitana. Não possuímos escritório físico em Recife: o atendimento é feito por equipe e equipamentos em campo, com orçamento centralizado pelo WhatsApp (11) 91777-6227.',
    },
    {
      question: 'A STIB atende eventos em Recife e no interior de Pernambuco?',
      answer: 'Sim! Atendemos Recife, Região Metropolitana (Caruaru, Olinda, Jaboatão, Paulista) e interior de Pernambuco. Para eventos fora da capital, entre em contato para verificar disponibilidade e condições de deslocamento.',
    },
    {
      question: 'Quais espaços de eventos em Recife são compatíveis com palestra silenciosa?',
      answer: 'A palestra silenciosa funciona em qualquer espaço: Centro de Convenções de Pernambuco, Hotel Atlante Plaza, Novotel Recife, Ritz Lagoa da Boa Viagem, espaços ao ar livre na Boa Viagem e qualquer outro local. Não há restrições de espaço.',
    },
    {
      question: 'Qual o prazo para contratar palestra silenciosa em Recife?',
      answer: 'Recomendamos pelo menos 20 dias de antecedência para eventos em Recife, considerando o planejamento logístico. Para eventos de grande porte, sugerimos 30 dias. Também atendemos demandas urgentes conforme disponibilidade.',
    },
    {
      question: 'O clima quente de Recife afeta os equipamentos?',
      answer: 'Não. Nossos equipamentos são certificados para uso em ambientes com temperatura de até 45°C e alta umidade. Funcionam perfeitamente em eventos ao ar livre em Recife, mesmo no verão nordestino.',
    },
    {
      question: 'A palestra silenciosa funciona para eventos na praia em Recife?',
      answer: 'Sim! Eventos na orla de Boa Viagem, Porto de Galinhas e outras praias de Pernambuco são um dos casos de uso mais populares. Sem caixas de som, sem poluição sonora, sem restrições de horário — perfeito para eventos à beira-mar.',
    },
  ],
  seoTitle: 'Palestra Silenciosa Recife | Aluguel Fones Sem Fio PE | STIB',
  seoDescription: 'Palestra silenciosa Recife: aluguel de fones sem fio para eventos corporativos, conferências e workshops em Pernambuco. Equipamentos e profissionais presentes em Recife, tecnologia premium. Orçamento: (11) 91777-6227.',
};

export default function RecifeLandingPage() {
  return <CityLandingPage cityData={recifeData} />;
}
